import React, {useMemo} from 'react';
import {ColumnBox, FlexBox} from "../ui/styled";
import {ImageItem} from "../common";
import styled, {useTheme} from "styled-components";
import useItemFunc from "../../common/hooks/useItemFunc";
import {useTranslation} from "react-i18next";


const DetailText = styled.div`
  font-size: 11px;
  color: ${props => props.theme.color.dark_200};
  font-weight: 500;
  line-height: 13px;
  height: 16px;
  margin-top: 4px;
`;
const DetailTextBold = styled.span`
  font-size: 11px;
  color: ${props => props.theme.color.dark_100};
  font-weight: bold;
  line-height: 16px;
  margin-top: 4px;
`;

const BoldBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Relative = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;

`;

const BoldBorderBox = styled(Relative)`
  position: relative;

  .imgItem {
    box-sizing: content-box;
    border: 3px solid ${props => props.theme.color.green_100};
    border-radius: 4px;
  }
`;


const ArrowBox = styled.div`
  display: flex;
  align-items: center;
  margin: 0 2px;
  height: 40px;
`;
const BorderArrowBox = styled(ArrowBox)`
  height: 38px;
`;
const SequenceItemBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 4px;
`;

const ItemFlex = styled.div`
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .imgItem {
    width: 32px;
    height: 32px;
    border-radius: 4px;
  }

  gap: 4px;
`;

const LlmItemSq = ({list}) => {
    const {t} = useTranslation();
    const {isFinalItem} = useItemFunc();
    const theme = useTheme();

    const customList = useMemo(() => {
        try {
            const reduced = list.reduce((sum, cur) => {
                const indexHasMin = sum.findIndex((data) => data?.minute === cur.minute);
                if (indexHasMin < 0) {
                    sum.push({
                        minute: cur.minute,
                        item_data: [{...cur, count: 1}]
                    })
                } else {

                    const alreadyExist = sum[indexHasMin].item_data.findIndex((data) => data.item_id === cur.item_id && data.type === cur.type);


                    if (alreadyExist > -1) {
                        sum[indexHasMin].item_data[alreadyExist].count += 1
                    } else {
                        sum[indexHasMin].item_data.push({...cur, count: 1})
                    }
                }
                return sum;
            }, [])


            return reduced
        } catch (e) {
            console.log(e)
            return []
        }
    }, [list]);
    return (
        <SequenceItemBox>
            {customList.map((data, index) => {
                return (
                    <FlexBox key={index} alignItems={'flex-start'}>
                        <ColumnBox alignItems={'center'}>
                            <ItemFlex>
                                {data.item_data.map((item, indexItem) => {
                                    const isFinal = isFinalItem(item.item_id);
                                    if (isFinal) {
                                        return <FinalItem data={item} key={indexItem + "final"}/>
                                    }
                                    return (
                                        <Item data={item} key={indexItem + "item"}/>
                                    )
                                })}

                            </ItemFlex>
                            <DetailText>{data.minute}{t('llm.min')}</DetailText>
                        </ColumnBox>
                        {index + 1 !== customList?.length && <ArrowBox>
                            <img src={`${theme.icon.path}/icn_forward.svg`} width={14}
                                 height={14}/>
                        </ArrowBox>}
                    </FlexBox>
                )
            })}
        </SequenceItemBox>
    );
};

const AbsoluteBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  opacity: 1;
  width: 16px;
  height: 16px;
`;

const CounterText = styled.span`
  font-weight: 500;
  font-size: 12px;
`;
const SoldAbsolute = styled.div`
  position: absolute;
`;

const ImageItemBox = styled.div`
  opacity: ${props => {
    let opacity = '1';
    if (props.type === 'ITEM_SOLD') {
      opacity = '0.5'
    }
    return opacity
  }};
`;
const FinalItem = ({data}) => {
    return (
        <BoldBorderBox>
            <ImageItemBox type={data.type}>
                <ImageItem itemId={Number(data.item_id)} width={32} height={32}/>
            </ImageItemBox>
            {data?.count && data.count > 1 &&
                <AbsoluteBox>
                    <CounterText>{data.count}</CounterText>
                </AbsoluteBox>}
            {data.type === 'ITEM_SOLD' &&
                <SoldAbsolute>
                    <img src={'/images/llm/icn_sold.png'} width={11} height={19} alt={''}/>
                </SoldAbsolute>
            }
        </BoldBorderBox>
    )
}

const Item = ({data}) => {
    return (
        <Relative>
            <ImageItemBox type={data.type}>
                <ImageItem itemId={Number(data.item_id)} width={32} height={32}/>
            </ImageItemBox>
            {data?.count && data.count > 1 &&
                <AbsoluteBox>
                    <CounterText>{data.count}</CounterText>
                </AbsoluteBox>}
            {data.type === 'ITEM_SOLD' &&
                <SoldAbsolute>
                    <img src={'/images/llm/icn_sold.png'} alt={''}/>
                </SoldAbsolute>
            }
        </Relative>
    )
}

export default LlmItemSq;